import { AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { post } from './http';

interface TabularDatasourcesApi {
	getAllowedOptionsForTable(
		authorizationToken: string,
		table: string,
		values: string[],
		configVersion?: string,
		productName?: string,
		effectiveDate?: string,
	): Promise<AxiosResponse<string[]>>;
}

interface TabularDatasourcesParams {
	columnValues: string[];
	configVersion?: string;
	effectiveDate?: string;
}

export default {
	getAllowedOptionsForTable(
		authorizationToken: string,
		table: string,
		values: string[],
		configVersion?: string,
		productName?: string,
		effectiveDate?: string,
	) {
		const params: TabularDatasourcesParams = { columnValues: values };
		if (configVersion) {
			params.configVersion = configVersion;
		}
		if (effectiveDate) {
			params.effectiveDate = effectiveDate;
		}
		const url = productName
			? `${getApiUrl()}/variable/v1/tabularDatasources/query/${table}?productName=${productName}`
			: `${getApiUrl()}/variable/v1/tabularDatasources/query/${table}`;
		return post(url, authorizationToken, params);
	},
} as TabularDatasourcesApi;
